<template>
    <div class="myAddresses view-container">
        <div class="myAddresses__content">
            <TitleText class="spacing-b-6" level="1">
                {{ $ml.get('myAddress') }}
            </TitleText>
            <address-card
                v-for="address in addresses"
                :key="address.id"
                :title="address.street + ', ' + address.number"
                :subtitle="address.city + ', ' + address.state + ', ' + address.zipCode"
                :selected="address.id === selectedAddressId"
                @edit="handleEdit('DataOnFileEditAddress', address.id)"
                @select="selectShippingAddress(address.id)"
            />
        </div>
        <div class="myAddresses__actions">
            <CieloButtonV2
                :transparent="true"
                :loading="false"
                @click="addAddress('DataOnFileEditAddress')"
            >
                <span v-text="$ml.get('addAddress')" />
            </CieloButtonV2>
            <CieloButtonV2
                :transparent="false"
                :loading="buttonIsLoading"
                @click="reviewAddress"
            >
                <span v-text="$ml.get('continue')" />
            </CieloButtonV2>
        </div>
    </div>
</template>

<script>
	import { mapGetters } from 'vuex';
	import TitleText from '@/components/template/TitleText';
	import AddressCard from '../components/AddressCard.vue';
	import CieloButtonV2 from '@/components/template/CieloButtonV2.vue';

  export default {
	components: {
		TitleText,
		AddressCard,
		CieloButtonV2
	},

	data() {
		return {
            buttonIsLoading: false,
			selectedAddressId: null,
		};
	},

	created() {
		this.selectedAddressId = this.selectedShippingAddress.id;
	},

	computed: {
		...mapGetters({
			addresses: 'dataOnFile/getAllAddresses',
			selectedShippingAddress: 'dataOnFile/getSelectedShippingAddress',
		}),
  	},

	methods: {
		handleEdit(routeName, id) {
			this.$store.commit('dataOnFile/setSelectedShippingAddressId', id);
			this.$store.dispatch('pipelineV2/pushTo', routeName);
		},
		selectShippingAddress(id) {
			this.selectedAddressId = id;
        },
		addAddress(routeName) {
			this.$store.commit('dataOnFile/setSelectedShippingAddressId', null);
			this.$store.dispatch('pipelineV2/pushTo', routeName);
		},
        reviewAddress() {
			this.$store.dispatch('dataOnFile/setSelectedShippingAddressId', this.selectedAddressId);
			this.$store.dispatch('pipelineV2/pushTo', 'DataOnFileReview');
		},
  	},
  };
</script>

<style scoped lang="scss">
	.myAddresses {
		&__actions {
			display: flex;
			gap: 16px;
			> * {
				flex: 1 1 50%;
				max-width: 50%;
			}
			@media screen and (max-width: 1024px) {
				flex-direction: column;
				align-items: center;
				> * {
					max-width: 100%;
					width: 100%;
				}
			}
		}
		.btn {
			min-width: initial;
		}
	}
</style>
